import {
  FAVORITE_CLIENT,
  FAVORITE_CLIENT_SUCCESS,
  FAVORITE_CLIENT_ERROR,
  LOAD_CLIENTS,
  LOAD_CLIENTS_ERROR,
  LOAD_CLIENTS_SUCCESS,
  UPDATE_CLIENT,
  VERIFY_RISK_CLIENT,
  UPDATE_STATE_CLIENT,
  UPLOAD_CLIENTS,
} from '../constants/clients';

import { SEND_PROPOSAL_SUCCESS } from '../constants/proposal';

const CLIENTS_INIT = {
  clientsSelected: [],
  clients: [],
  loading: false,
  error: false,
  lastQuery: '',
};

export default (state = CLIENTS_INIT, action) => {
  switch (action.type) {

    case FAVORITE_CLIENT:
      return {
        ...state,
        clients: state.clients.map(client => (
          client.clienteId === action.payload.clienteId
            ? ({ ...client, favoriteClientLoading: true })
            : client
        )),
      };

    case FAVORITE_CLIENT_SUCCESS:
      return {
        ...state,
        clients: state.clients.map((client) => {
          if (client.clienteId === action.payload.clienteId) {
            return { ...client, favoriteClientLoading: false, favorito: !client.favorito };
          }

          return client;
        }),
      };

    case FAVORITE_CLIENT_ERROR:
      return {
        ...state,
        clients: state.clients.map((client) => {
          if (client.clienteId === action.payload.clienteId) {
            return { ...client, favoriteClientLoading: false };
          }

          return client;
        }),
      };

    case SEND_PROPOSAL_SUCCESS:
      return {
        ...state,
        clients: state.clients.map(client => ({
          ...client,
          isSelected: false,
          isVisible: true,
          quantity: 0,
        })),
      };

    case LOAD_CLIENTS:
      return {
        ...state,
        loading: true,
        clientsSelected: action.clientsSelected,
      };

    case LOAD_CLIENTS_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };

    case LOAD_CLIENTS_SUCCESS:
      let clients = action.payload;

      if (state.clientsSelected) {
        const searchedClients = clients.filter(client => !state.clientsSelected.find(clientsSelected => clientsSelected.clienteId === client.clienteId));
        clients = state.clientsSelected.concat(searchedClients);
      }

      return {
        ...state,
        loading: false,
        clients: clients
      };

    case UPDATE_CLIENT:
      return {
        ...state,
      };

    case VERIFY_RISK_CLIENT:
      return {
        ...state,
        loading: true,
      };

    case UPLOAD_CLIENTS:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_STATE_CLIENT:
      return {
        ...state,
        clients: action.payload.clients,
      };

    default:
      return state;
  }
};
